<template>
  <v-app id="evaluation">
    <v-container style="color: #CDCDCD">
      <v-row>
        <v-col sm="6" cols="12">
          <div class="font-24 font-weight-bold montserrat">
            {{ StudentName ? StudentName : "[student’s name]" }} Level Test
            Report
          </div>
        </v-col>
        <v-col v-show="next == 1 ? true : false">
          <AudioTwo
            v-if="fileName"
            :url="fileName"
            playerid="audio-player"
            class="ml-lg-5"
          />
        </v-col>
      </v-row>
      <v-row
        justify="center"
        :class="$vuetify.breakpoint.smAndUp ? 'my-15' : prev == 2 ? 'w3-animate-left mt-5' : 'w3-animate-right mt-5'"
        v-show="next == 1 ? true : false"
        v-touch="{
          left: () => swipe('Left'),
          right: () => swipe('Right'),
        }"
      >
        <v-col sm="4" cols="12">
          <p class="font-24 font-weight-bold">Score</p>
          <PieChartNew />
        </v-col>
        <v-col v-show="$vuetify.breakpoint.smAndUp" cols="1"></v-col>
        <v-col sm="4" cols="12">
          <p class="font-24 font-weight-bold">Level</p>
          <v-card
            color="#10192B"
            elevation="0"
            class="py-5"
            style="border-radius: 20px"
          >
            <BarChartNew />
          </v-card>
        </v-col>
      </v-row>
      <v-row
        :class="$vuetify.breakpoint.smAndUp ? 'my-15' : prev == 3 ? 'w3-animate-left mt-5' : 'w3-animate-right mt-5'"
        v-show="next == 2 ? true : windowwidth > 1200 ? true : false"
        v-touch="{
          left: () => swipe('Left'),
          right: () => swipe('Right'),
        }"
      >
        <v-col>
          <v-card
            color="#10192B"
            elevation="0"
            height="500px"
            class="card-bg"
            :class="$vuetify.breakpoint.smAndUp ? 'px-15 py-15' : 'px-5 py-5'"
            style="border-radius: 20px; color: #CDCDCD"
          >
            <p
              class="font-weight-bold"
              :class="$vuetify.breakpoint.smAndUp ? 'font-24' : 'font-14'"
            >
              Instructor’s Comments
            </p>
            <p
              class="fw-light mb-0"
              :class="$vuetify.breakpoint.smAndUp ? 'font-18' : 'font-14'"
            >
              {{ StudentData.comment }}
            </p>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        :class="$vuetify.breakpoint.smAndUp ? 'my-15' : prev == 4 ? 'w3-animate-left mt-5' : 'w3-animate-right mt-5'"
        v-show="next == 3 ? true : windowwidth > 1200 ? true : false"
        v-touch="{
          left: () => swipe('Left'),
          right: () => swipe('Right'),
        }"
      >
        <v-col>
          <v-card
            color="#10192B"
            elevation="0"
            class="card-bg"
            :class="$vuetify.breakpoint.smAndUp ? 'px-15 py-15' : 'px-5 py-5'"
            style="border-radius: 20px; color: #CDCDCD"
          >
            <v-row>
              <v-col sm="6" cols="12">
                <p
                  class="font-weight-bold"
                  :class="$vuetify.breakpoint.smAndUp ? 'font-24' : 'font-14'"
                >
                  Sentence Correction
                </p>
                <v-row v-for="(docs) in StudentData.feedBack.correction" :key="docs">
                  <v-col>
                    
                      <v-col>
                        <p
                          class="fw-light"
                          :class="
                            $vuetify.breakpoint.smAndUp ? 'font-24' : 'font-18'
                          "
                        >
                          {{ docs.worng }}
                        </p>
                        <p
                          class=" fw-medium d-flex align-center"
                          :class="
                            $vuetify.breakpoint.smAndUp ? 'font-24' : 'font-18'
                          "
                          style="color: #8BDCFF"
                        >
                          <span
                            class="font-12 fw-semibold correct-bg px-2 py-2 mr-5 white--text"
                          >
                            추천
                          </span>
                          {{ docs.correct }}
                        </p>
                      </v-col>
                    
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                  <div class="montserrat font-18 font-weight-bold">
                    Words to be Careful With
                  </div>
                  <div class="montserrat font-18 fw-medium mt-1">
                    <v-row>
                      <v-col>
                        <wordAudio
                          v-if="audioVal1"
                          number-seq="1."
                          :word-audio="StudentData.feedBack.word[0]"
                          :url="audioVal1"
                          :texttospeech="texttospeech1"
                          playerid="audio-player"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <wordAudio
                          v-if="audioVal2"
                          number-seq="2."
                          :word-audio="StudentData.feedBack.word[1]"
                          :url="audioVal2"
                          :texttospeech="texttospeech2"
                          playerid="audio-player"
                        />
                      </v-col>
                    </v-row>

                  </div>
                </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        :class="$vuetify.breakpoint.smAndUp ? 'my-15' : prev == 4 ? 'w3-animate-left mt-5' : 'w3-animate-right mt-5'"
        v-show="next == 4 ? true : windowwidth > 1200 ? true : false"
        v-touch="{
          left: () => swipe('Left'),
          right: () => swipe('Right'),
        }"
      >
        <v-col>
          <v-card
            color="#10192B"
            elevation="0"
            min-height="500px"
            class="card-bg"
            :class="$vuetify.breakpoint.smAndUp ? 'px-15 py-15' : 'px-5 py-5'"
            style="border-radius: 20px; color: #CDCDCD"
          >
            <p
              class="font-weight-bold"
              :class="$vuetify.breakpoint.smAndUp ? 'font-24' : 'font-14'"
            >
              Level Analysis
            </p>
            <v-row>
              <v-col>
                <v-row no-gutters>
                  <v-col>
                    <p
                      class="font-weight-bold"
                      :class="
                        $vuetify.breakpoint.smAndUp ? 'font-18' : 'font-14'
                      "
                    >
                      Total Score
                    </p>
                  </v-col>
                  <v-col>
                    <p class="font-64 fw-semibold text-right">
                      <span>{{ StudentData.totalScore }}</span>
                      <span class="font-18 fw-medium ml-0">/500</span>
                    </p>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <p
                      class="font-weight-bold"
                      :class="
                        $vuetify.breakpoint.smAndUp ? 'font-24' : 'font-18'
                      "
                    >
                      Skill
                    </p>
                    <div
                      class="font-18 fw-medium"
                      :class="
                        $vuetify.breakpoint.smAndUp ? 'font-18' : 'font-14'
                      "
                    >
                      <p>
                        Pronunciation
                      </p>
                      <p>Grammar</p>
                      <p>Vocabulary</p>
                      <p>Comprehension</p>
                      <p>Fluency</p>
                    </div>
                  </v-col>
                  <v-col class="text-right">
                    <p
                      class="font-weight-bold"
                      :class="
                        $vuetify.breakpoint.smAndUp ? 'font-24' : 'font-18'
                      "
                    >
                      Score
                    </p>
                    <div
                      class="font-18 fw-medium"
                      :class="
                        $vuetify.breakpoint.smAndUp ? 'font-18' : 'font-14'
                      "
                    >
                      <p>
                        {{ StudentData.score.pronunciation.value * 10 }}
                      </p>
                      <p>
                        {{ StudentData.score.grammar.value * 10 }}
                      </p>
                      <p>
                        {{ StudentData.score.vocabulary.value * 10 }}
                      </p>
                      <p>
                        {{ StudentData.score.comprehension.value * 10 }}
                      </p>
                      <p>
                        {{ StudentData.score.fluency.value * 10 }}
                      </p>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-show="$vuetify.breakpoint.smAndUp" cols="1"></v-col>
              <v-col sm="6" cols="12">
                <v-row no-gutters>
                  <v-col>
                    <p
                      class="font-weight-bold"
                      :class="
                        $vuetify.breakpoint.smAndUp
                          ? 'font-18 mb-10'
                          : 'font-14'
                      "
                    >
                      Score Comparison*
                    </p>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col class="d-flex justify-start" sm="3" cols="4">
                    <v-img
                      src="@/assets/images/LevelTest/reports/mega_blue.png"
                    ></v-img>
                  </v-col>
                  <v-col v-show="$vuetify.breakpoint.smAndUp" cols="2"></v-col>
                  <v-col>
                    <v-card
                      elevation="0"
                      class="text-center custom-outlined-card fw-light"
                      :class="
                        $vuetify.breakpoint.smAndUp
                          ? 'font-18 px-5 py-5'
                          : 'font-14 px-2 py-2'
                      "
                    >
                      <v-row no-gutters align="center">
                        <v-col>
                          <span> Level {{ StudentData.level }} </span>
                        </v-col>
                        <v-col>
                          <span v-html="MegaLevelName(StudentData.level)">
                          </span>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col
                    class="d-flex flex-column justify-start text-right"
                    sm="3"
                    cols="4"
                  >
                    <v-img
                      src="@/assets/images/LevelTest/reports/toeic-logo.png"
                    ></v-img>
                    <span
                      :class="
                        $vuetify.breakpoint.smAndUp ? 'font-18' : 'font-12'
                      "
                      >Speaking</span
                    >
                  </v-col>
                  <v-col v-show="$vuetify.breakpoint.smAndUp" cols="2"></v-col>
                  <v-col>
                    <v-card
                      elevation="0"
                      class="text-center custom-outlined-card fw-light"
                      :class="
                        $vuetify.breakpoint.smAndUp
                          ? 'font-18 px-5 py-5'
                          : 'font-14 px-2 py-2'
                      "
                      height="100%"
                    >
                      <v-row no-gutters align="center">
                        <v-col>
                          <span>
                            Level {{ ToeicLevel(StudentData.level) }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col
                    class="d-flex flex-column justify-start text-right"
                    sm="3"
                    cols="4"
                  >
                    <v-img
                      src="@/assets/images/LevelTest/reports/OPIc-logo.png"
                    ></v-img>
                  </v-col>
                  <v-col v-show="$vuetify.breakpoint.smAndUp" cols="2"></v-col>
                  <v-col>
                    <v-card
                      elevation="0"
                      class="text-center custom-outlined-card fw-light"
                      :class="
                        $vuetify.breakpoint.smAndUp
                          ? 'font-18 px-5 py-5'
                          : 'font-14 px-2 py-2'
                      "
                      height="100%"
                    >
                      <v-row no-gutters align="center">
                        <v-col>
                          <span>
                            {{ OpicLevel(StudentData.level) }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        :class="$vuetify.breakpoint.smAndUp ? 'my-15' : 'mt-5'"
        v-show="next == 5 ? true : windowwidth > 1200 ? true : false"
        v-touch="{
          left: () => swipe('Left'),
          right: () => swipe('Right'),
        }"
      >
        <v-col>
          <v-card
            color="#10192B"
            elevation="0"
            min-height="500px"
            class="card-bg"
            :class="$vuetify.breakpoint.smAndUp ? 'px-15 py-15' : 'px-5 py-5'"
            style="border-radius: 20px; color: #CDCDCD"
          >
            <v-row align="center">
              <v-col sm="6" cols="12">
                <p class="font-14 font-weight-bold">Pronunciation</p>
                <p class="font-14 fw-light mb-0">
                  {{ pronunciation[StudentData.score.pronunciation.value - 1] }}
                </p>
              </v-col>
              <v-col>
                <div class="font-18 font-weight-bold" style="color: #02A9F4">
                  {{ StudentData.score.pronunciation.value * 10 }}
                </div>
                <v-progress-linear
                  rounded
                  :value="StudentData.score.pronunciation.value * 10"
                  background-color="#000C17"
                  color="#02A9F4"
                ></v-progress-linear>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col sm="6" cols="12">
                <p class="font-14 font-weight-bold">Grammar</p>
                <p class="font-14 fw-light mb-0">
                  {{ grammar[StudentData.score.grammar.value - 1] }}
                </p>
              </v-col>
              <v-col>
                <div class="font-18 font-weight-bold" style="color: #02A9F4">
                  {{ StudentData.score.grammar.value * 10 }}
                </div>
                <v-progress-linear
                  rounded
                  :value="StudentData.score.grammar.value * 10"
                  background-color="#000C17"
                  color="#02A9F4"
                ></v-progress-linear>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col sm="6" cols="12">
                <p class="font-14 font-weight-bold">Vocabulary</p>
                <p class="font-14 fw-light mb-0">
                  {{ vocabulary[StudentData.score.vocabulary.value - 1] }}
                </p>
              </v-col>
              <v-col>
                <div class="font-18 font-weight-bold" style="color: #02A9F4">
                  {{ StudentData.score.vocabulary.value * 10 }}
                </div>
                <v-progress-linear
                  rounded
                  :value="StudentData.score.vocabulary.value * 10"
                  background-color="#000C17"
                  color="#02A9F4"
                ></v-progress-linear>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col sm="6" cols="12">
                <p class="font-14 font-weight-bold">Comprehension</p>
                <p class="font-14 fw-light mb-0">
                  {{ comprehension[StudentData.score.comprehension.value - 1] }}
                </p>
              </v-col>
              <v-col>
                <div class="font-18 font-weight-bold" style="color: #02A9F4">
                  {{ StudentData.score.comprehension.value * 10 }}
                </div>
                <v-progress-linear
                  rounded
                  :value="StudentData.score.comprehension.value * 10"
                  background-color="#000C17"
                  color="#02A9F4"
                ></v-progress-linear>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col sm="6" cols="12">
                <p class="font-14 font-weight-bold">Fluency</p>
                <p class="font-14 fw-light mb-0">
                  {{ fluency[StudentData.score.fluency.value - 1] }}
                </p>
              </v-col>
              <v-col>
                <div class="font-18 font-weight-bold" style="color: #02A9F4">
                  {{ StudentData.score.fluency.value * 10 }}
                </div>
                <v-progress-linear
                  rounded
                  :value="StudentData.score.fluency.value * 10"
                  background-color="#000C17"
                  color="#02A9F4"
                ></v-progress-linear>
              </v-col>
            </v-row>
            <v-row class="mt-15">
              <v-col class="d-flex justify-end">
                <v-btn
                  outlined
                  color="white"
                  class="font-14 font-weight-bold"
                  large
                  :width="$vuetify.breakpoint.smAndUp ? '20%' : '100%'"
                  style="border-radius: 10px; text-transform: none"
                  @click="feedBack()"
                >
                  Rate us
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  outlined
                  color="white"
                  class="font-14 font-weight-bold px-14"
                  large
                  :width="$vuetify.breakpoint.smAndUp ? '20%' : '100%'"
                  style="border-radius: 10px; text-transform: none; "
                  @click="enrollment()"
                >
                 Enroll now! 
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-layout justify-center>
        <v-flex
          lg3
          class="text-center mt-10"
          v-show="windowwidth < 1200 ? true : false"
        >
          <v-btn
            class="mx-2 elevation-0"
            fab
            dark
            style="height:15px; width:15px;"
            :color="next == 1 ? 'rgb(3, 119, 188)' : 'rgb(16, 25, 43)'"
            @click="nextslide('1')"
          >
          </v-btn>
          <v-btn
            class="mx-2 elevation-0"
            fab
            dark
            style="height:15px; width:15px;"
            :color="next == 2 ? 'rgb(3, 119, 188)' : 'rgb(16, 25, 43)'"
            @click="nextslide('2')"
          >
          </v-btn>
          <v-btn
            class="mx-2 elevation-0"
            fab
            dark
            style="height:15px; width:15px;"
            :color="next == 3 ? 'rgb(3, 119, 188)' : 'rgb(16, 25, 43)'"
            @click="nextslide('3')"
          >
          </v-btn>
          <v-btn
            class="mx-2 elevation-0"
            fab
            dark
            style="height:15px; width:15px;"
            :color="next == 4 ? 'rgb(3, 119, 188)' : 'rgb(16, 25, 43)'"
            @click="nextslide('4')"
          >
          </v-btn>
          <v-btn
            class="mx-2 elevation-0"
            fab
            dark
            style="height:15px; width:15px;"
            :color="next == 5 ? 'rgb(3, 119, 188)' : 'rgb(16, 25, 43)'"
            @click="nextslide('5')"
          >
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- <v-container fluid class="px-lg-10">
      <v-layout row justify-lg-space-between>
        <v-flex
          lg5
          xs12
          class="text-left white--text mt-lg-2 mt-10 font18 font24"
        >
          <span style=" font-family: Arial, Helvetica, sans-serif !important;">
            {{ StudentName ? StudentName : "[student’s name]" }}
          </span>
          Level Test Report
        </v-flex> -->
    <!-- <v-flex lg2 xs12 class="mt-lg-0 mt-5"> -->
    <!-- <v-flex lg6 xs12 class="mt-lg-n6 mt-5"> -->
    <!-- <audio controls v-if="audioVal1" class="audio-xs-width" >
                        <source :src="audioVal1" type="audio/mp3">
                        </audio> -->

    <!-- <AudioTwo
            v-if="fileName"
            :url="fileName"
            playerid="audio-player"
            class="ml-lg-5"
          /> -->
    <!-- <a :href="'http://121.78.147.57:8000/Eple_Web/Record.action?call_date='+StudentRecordData.call_date+'&phone_number='+StudentRecordData.phone+'&company_code=ueducation'" target="_blank"> <v-btn class="white--text class-audio-btn"> 수업녹음파일 </v-btn> </a> -->
    <!-- </v-flex>
      </v-layout> -->

    <!-- one -->

    <!-- <v-layout
        row
        justify-center
        :class="
          prev == 2
            ? 'w3-animate-left '
            : 'w3-animate-right '
        "
        v-show="next == 1 ? true : false"
        v-touch="{
          left: () => swipe('Left'),
          right: () => swipe('Right'),
        }"
      >
        <v-flex lg6 xs10 class="white--text px-lg-10 px-2">
          <span class="text-h6"> Score </span>
          <PieChartNew class="mt-5 ml-n16" />
        </v-flex>

        <v-flex lg6 xs10 class="white--text mt-lg-0 px-lg-16 mt-16">
          <span class="text-h6"> Level </span>
          <v-card
            color="rgb(16, 25, 43)"
            class="rounded-lg mt-lg-3 pb-4 elevation-0"
          >
            <BarChartNew />
          </v-card>
        </v-flex>
      </v-layout> -->

    <!-- two -->

    <!-- <v-layout
        row
        justify-center
        :class="
          prev == 3
            ? 'w3-animate-left '
            : 'w3-animate-right '
        "
        v-show="next == 2 ? true : windowwidth > 1200 ? true : false"
        v-touch="{
          left: () => swipe('Left'),
          right: () => swipe('Right'),
        }"
      >
        <v-flex lg12 xs12 class="white--text px-lg-10 px-2">
          <v-card
            class="rounded-lg px-lg-2 py-lg-10 mt-lg-3 elevation-0 card-height card-bg white--text"
          >
            <div
              class="font24 font15 font-weight-bold px-lg-16 px-5 py-lg-0 py-10"
            >
              Instructor’s Comments
            </div>
            <div
              class="mt-lg-3 px-lg-16 px-5 font15"
              style="color:rgb(205, 205, 205) !important"
            >
              {{ StudentData.comment }}
            </div>
          </v-card>
        </v-flex>
      </v-layout> -->

    <!-- three -->

    <!-- <v-layout
        row
        justify-center
        :class="
          prev == 4
            ? 'w3-animate-left '
            : 'w3-animate-right '
        "
        v-show="next == 3 ? true : windowwidth > 1200 ? true : false"
        v-touch="{
          left: () => swipe('Left'),
          right: () => swipe('Right'),
        }"
      >
        <v-flex lg12 xs12 class="white--text px-lg-10 px-2 ">
          <v-card
            class="rounded-lg px-lg-2 py-lg-16 mt-lg-3 elevation-0 card-height card-bg white--text px-2"
          >
            <v-layout row class="ml-lg-16 px-lg-10 px-6">
              <v-flex lg6 xs12 class="mt-lg-6 mt-10 ">
                <div class="text-lg-h5 text-body-1">
                  Sentence Correction
                </div>
                <div>
                  <p class="mt-lg-5 mt-2">
                    <v-icon medium color="red"> mdi-close </v-icon>
                    <span
                      class="text-h6 text-lg-h6"
                      style="color:rgb(205, 205, 205) !important"
                    >
                      {{ StudentData.feedBack.correction[0].worng }}
                    </span>
                  </p>
                  <p class="">
                    <v-icon medium color="green"> mdi-check </v-icon>
                    <span
                      style="color:rgb(139, 220, 255) !important"
                      class=" text-h6 text-lg-h6 font-weight-medium"
                    >
                      {{ StudentData.feedBack.correction[0].correct }}
                    </span>
                  </p>
                </div>
                <div class="mt-18">
                  <p class="mt-lg-16">
                    <v-icon medium color="red"> mdi-close </v-icon>
                    <span
                      class="text-h6 text-lg-h6"
                      style="color:rgb(205, 205, 205) !important"
                    >
                      {{ StudentData.feedBack.correction[1].worng }}
                    </span>
                  </p>
                  <p class="">
                    <v-icon medium color="green"> mdi-check </v-icon>
                    <span
                      style="color:rgb(139, 220, 255) !important"
                      class="text-h6 text-lg-h6 font-weight-medium"
                    >
                      {{ StudentData.feedBack.correction[1].correct }}
                    </span>
                  </p>
                </div>
              </v-flex>

              <v-flex lg6 xs12 class="mt-lg-6 mt-2">
                <div class="text-lg-h5 text-body-1">
                  Words to be Careful with
                </div>
                <div>
                  <p class="mt-lg-5 mt-1">
                    <span
                      class="text-h6 text-lg-h6"
                      style="color:rgb(205, 205, 205) !important"
                    >
                      {{ StudentData.feedBack.word[0] }}
                    </span>
                  </p>
                  <p
                    :class="
                      prev == 4
                        ? 'mt-n2 w3-animate-left'
                        : 'mt-n2 w3-animate-right'
                    "
                  >
                    {{ word1_audio(StudentData.feedBack.word[0]) }}
                    <v-flex> -->
    <!-- <audio controls v-if="audioVal1" class="audio-xs-width" >
                                                                    <source :src="audioVal1" type="audio/mp3">
                                                                </audio> -->
    <!-- <AudioOne
                        v-if="audioVal1"
                        :url="audioVal1"
                        playerid="audio-player"
                      />
                    </v-flex>
                  </p>

                  <div class="mt-17">
                    <p class="mt-lg-0 mt-n2">
                      <span
                        class="text-h6 text-lg-h6"
                        style="color:rgb(205, 205, 205) !important"
                      >
                        {{ StudentData.feedBack.word[1] }}
                      </span>
                    </p>
                    <p
                      :class="
                        prev == 4
                          ? 'mt-n2 w3-animate-left'
                          : 'mt-n2 w3-animate-right'
                      "
                    >
                      {{ word2_audio(StudentData.feedBack.word[1]) }} -->
    <!-- 
                                                                <audio controls v-if="audioVal2" class="audio-xs-width">
                                                                    <source :src="audioVal2" type="audio/mp3">
                                                                </audio> -->

    <!-- <AudioOne
                        v-if="audioVal2"
                        :url="audioVal2"
                        playerid="audio-player"
                      />
                    </p>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout> -->

    <!-- four -->

    <!-- <v-layout
        row
        justify-center
        :class="
          prev == 4
            ? 'w3-animate-left '
            : 'w3-animate-right '
        "
        v-show="next == 4 ? true : windowwidth > 1200 ? true : false"
        v-touch="{
          left: () => swipe('Left'),
          right: () => swipe('Right'),
        }"
      >
        <v-flex lg12 xs12 class="white--text px-lg-10 px-2">
          <v-card
            class="rounded-lg px-lg-2 py-lg-16 mt-lg-3 elevation-0 card-height card-bg white--text"
          >
            <div class="text-lg-h5 ml-lg-16 px-lg-10 text-body-1 px-5 py-5">
              Level Analysis
            </div>

            <v-layout row class="ml-lg-16 px-lg-10 mt-lg-5 px-8 mt-5">
              <v-flex lg6 xs12>
                <v-layout justify-space-around>
                  <v-flex lg6 xs6>
                    <v-list-item-content>
                      <span
                        class="font-weight-medium text-subtitle-2 text-lg-body-1"
                      >
                        Total Score</span
                      >
                    </v-list-item-content>
                  </v-flex>
                  <v-flex lg6 xs6 class=" mt-n3 ml-lg-9 ml-1">
                    <v-list-item-content>
                      <span>
                        <span class="text-lg-h2 text-h3 font-weight-bold">
                          {{ StudentData.totalScore }}
                        </span>
                        <span
                          class="text-body-1  font-weight-medium ml-n3"
                          style="color:rgb(205, 205, 205) !important"
                        >
                          / 500
                        </span>
                      </span>
                    </v-list-item-content>
                  </v-flex>
                </v-layout>
                <v-layout justify-space-around>
                  <v-flex lg6>
                    <v-list-item-content>
                      <span class="text-lg-body-1 font-weight-bold">
                        Skill</span
                      >
                      <span class="text-lg-subtitle-2 mt-lg-3 mt-4">
                        Pronunciation
                      </span>
                      <span class="text-lg-subtitle-2 mt-lg-3 mt-4">
                        Grammar
                      </span>
                      <span class="text-lg-subtitle-2 mt-lg-3 mt-4">
                        Vocabulary
                      </span>
                      <span class="text-lg-subtitle-2 mt-lg-3 mt-4">
                        Comprehension
                      </span>
                      <span class="text-lg-subtitle-2 mt-lg-3 mt-4">
                        Fluency
                      </span>
                    </v-list-item-content>
                  </v-flex>
                  <v-flex lg6 class="ml-lg-16 ml-16">
                    <v-list-item-content class="ml-lg-5 ml-7">
                      <span class="text-lg-body-1 font-weight-bold ml-lg-16">
                        Score</span
                      >
                      <span
                        class="text-lg-subtitle-2 mt-lg-3 mt-4  ml-lg-16 pl-lg-7 ml-7"
                      >
                        {{ StudentData.score.pronunciation.value * 10 }}
                      </span>
                      <span
                        class="text-lg-subtitle-2 mt-lg-3 mt-4  ml-lg-16 pl-lg-7 ml-7"
                      >
                        {{ StudentData.score.grammar.value * 10 }}
                      </span>
                      <span
                        class="text-lg-subtitle-2 mt-lg-3 mt-4  ml-lg-16 pl-lg-7 ml-7"
                      >
                        {{ StudentData.score.vocabulary.value * 10 }}
                      </span>
                      <span
                        class="text-lg-subtitle-2 mt-lg-3 mt-4  ml-lg-16 pl-lg-7 ml-7"
                      >
                        {{ StudentData.score.comprehension.value * 10 }}</span
                      >
                      <span
                        class="text-lg-subtitle-2 mt-lg-3 mt-4  ml-lg-16 pl-lg-7 ml-7"
                      >
                        {{ StudentData.score.fluency.value * 10 }}
                      </span>
                    </v-list-item-content>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex lg6>
                <v-layout>
                  <v-flex lg12 xs6>
                    <v-list-item-content>
                      <span
                        class="font-weight-medium text-subtitle-2 text-lg-body-1"
                      >
                        Score Comparison*
                      </span>
                    </v-list-item-content>
                  </v-flex>
                </v-layout>
                <v-layout row class="ml-lg-n16">
                  <v-flex lg12 xs12 class="ml-lg-n1">
                    <v-list-item-content>
                      <v-flex lg6 xs5 class="ml-lg-n8 ml-n3">
                        <v-img
                          src="@/assets/images/LevelTest/reports/mega_blue.png"
                          aspect-ratio="1"
                          class="logo-mega"
                          contain
                        ></v-img>
                      </v-flex>
                      <v-flex lg6 xs7 class="ml-lg-n1 ml-2">
                        <v-card
                          style="border:1px solid #9E9E9E;background: transparent; border-radius: 10px;"
                          outlined
                          class="white--text elevation-0 text-center px-1 px-lg-2 py-1 py-lg-4 ml-lg-4 mt-0 text-lg-body-2"
                        >
                          <v-layout>
                            <v-flex
                              lg6
                              class="mt-lg-2 mt-2 text-lg-body-1 text-caption"
                            >
                              Level {{ StudentData.level }}
                            </v-flex>

                            <v-flex
                              lg6
                              class="text-lg-body-1 text-caption mt-lg-2 mt-2"
                            >
                              <span v-html="MegaLevelName(StudentData.level)">
                              </span>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-list-item-content>
                  </v-flex>

                  <v-flex lg12 xs12 class="ml-lg-n5 ml-n1">
                    <v-list-item-content>
                      <v-flex lg6 xs5>
                        <v-img
                          src="@/assets/images/LevelTest/reports/toeic-logo.png"
                          aspect-ratio="1"
                          class="logo-mega3"
                          contain
                        ></v-img>
                        <div
                          class="text-center ml-lg-10 text-lg-body-1 text-body-2 ml-5"
                        >
                          Speaking
                        </div>
                      </v-flex>
                      <v-flex lg6 xs7 class="ml-lg-n5">
                        <v-card
                          style="border:1px solid #9E9E9E;background: transparent; border-radius: 10px;"
                          outlined
                          class="white--text elevation-0 text-center px-1 px-lg-2 py-3 py-lg-5 ml-lg-4 mt-0 text-lg-body-1 text-caption"
                        >
                          Level {{ ToeicLevel(StudentData.level) }}
                        </v-card>
                      </v-flex>
                    </v-list-item-content>
                  </v-flex>

                  <v-flex lg12 xs12 class="ml-lg-n3 ml-n1">
                    <v-list-item-content>
                      <v-flex lg6 xs5>
                        <v-img
                          src="@/assets/images/LevelTest/reports/OPIc-logo.png"
                          aspect-ratio="1"
                          class="logo-mega2"
                          contain
                        ></v-img>
                      </v-flex>
                      <v-flex lg6 xs7 class="ml-lg-n7">
                        <v-card
                          style="border:1px solid #9E9E9E;background: transparent; border-radius: 10px;"
                          outlined
                          class="white--text elevation-0 text-center px-1 px-lg-2 py-3 py-lg-5 ml-lg-4  mt-0 text-lg-body-1 text-caption"
                        >
                          {{ OpicLevel(StudentData.level) }}
                        </v-card>
                      </v-flex>
                    </v-list-item-content>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout> -->

    <!-- five -->

    <!-- <v-layout
        row
        justify-center
        class="w3-animate-right "
        v-show="next == 5 ? true : windowwidth > 1200 ? true : false"
        v-touch="{
          left: () => swipe('Left'),
          right: () => swipe('Right'),
        }"
      >
        <v-flex lg12 xs12 class="white--text px-lg-10 px-2">
          <v-card
            class="rounded-lg px-lg-2 py-lg-3 mt-lg-3 px-10 py-1 elevation-0  card-height2 card-bg white--text"
          >
            <v-layout row justify-lg-space-between class="mt-5">
              <v-flex lg6 xs12 class="pr-10 px-lg-16">
                <v-list-item-content>
                  <span class="text-lg-body-1 font-weight-bold">
                    Pronunciation
                  </span> -->
    <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
    <!-- <span
                    class="text-lg-subtitle-1 mt-lg-2 mt-1"
                    style="color:rgb(205, 205, 205) !important"
                  >
                    {{
                      pronunciation[StudentData.score.pronunciation.value - 1]
                    }}
                  </span>
                </v-list-item-content>
              </v-flex> -->

    <!-- <v-flex lg6 xs12 class="px-lg-16 px-1">
                <v-list-item-content class="mt-lg-2 mt-n4">
                  <span class="text-lg-h5 font-weight-bold progress-color1">
                    {{ StudentData.score.pronunciation.value * 10 }}
                  </span> -->
    <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
    <!-- <v-progress-linear
                    :value="StudentData.score.pronunciation.value * 10"
                    rounded
                    color="rgb(0, 84, 122)"
                    height="5"
                  ></v-progress-linear>
                </v-list-item-content>
              </v-flex>
              <v-flex lg6 class="pr-10 px-lg-16 mt-lg-0 mt-n3">
                <v-list-item-content>
                  <span class="text-lg-body-1 font-weight-bold"> Grammar </span> -->
    <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
    <!-- <span
                    class="text-lg-subtitle-1 mt-lg-2 mt-1"
                    style="color:rgb(205, 205, 205) !important"
                  >
                    {{ grammar[StudentData.score.grammar.value - 1] }}
                  </span>
                </v-list-item-content>
              </v-flex>

              <v-flex lg6 class="px-lg-16 px-1">
                <v-list-item-content class="mt-lg-2 mt-n4">
                  <span class="text-lg-h5 font-weight-bold progress-color1">
                    {{ StudentData.score.grammar.value * 10 }}
                  </span> -->
    <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
    <!-- <v-progress-linear
                    :value="StudentData.score.grammar.value * 10"
                    rounded
                    color="rgb(0, 84, 122)"
                    height="5"
                  ></v-progress-linear>
                </v-list-item-content>
              </v-flex>
              <v-flex lg6 class="pr-10 px-lg-16 mt-lg-0 mt-n3">
                <v-list-item-content>
                  <span class="text-lg-body-1 font-weight-bold">
                    Vocabulary
                  </span> -->
    <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
    <!-- <span
                    class="text-lg-subtitle-1 mt-lg-2 mt-1"
                    style="color:rgb(205, 205, 205) !important"
                  >
                    {{ vocabulary[StudentData.score.vocabulary.value - 1] }}
                  </span>
                </v-list-item-content>
              </v-flex>

              <v-flex lg6 class="px-lg-16 px-1">
                <v-list-item-content class="mt-lg-2 mt-n4">
                  <span class="text-lg-h5 font-weight-bold progress-color1">
                    {{ StudentData.score.vocabulary.value * 10 }}
                  </span> -->
    <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
    <!-- <v-progress-linear
                    :value="StudentData.score.vocabulary.value * 10"
                    rounded
                    color="rgb(0, 84, 122)"
                    height="5"
                  ></v-progress-linear>
                </v-list-item-content>
              </v-flex>
              <v-flex lg6 class="pr-10 px-lg-16 mt-lg-0 mt-n3">
                <v-list-item-content>
                  <span class="text-lg-body-1 font-weight-bold">
                    Comprehension
                  </span> -->
    <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
    <!-- <span
                    class="text-lg-subtitle-1 mt-lg-2 mt-1"
                    style="color:rgb(205, 205, 205) !important"
                  >
                    {{
                      comprehension[StudentData.score.comprehension.value - 1]
                    }}
                  </span>
                </v-list-item-content>
              </v-flex>

              <v-flex lg6 class="px-lg-16 px-1">
                <v-list-item-content class="mt-lg-2 mt-n4">
                  <span class="text-lg-h5 font-weight-bold progress-color1">
                    {{ StudentData.score.comprehension.value * 10 }}
                  </span> -->
    <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
    <!-- <v-progress-linear
                    :value="StudentData.score.comprehension.value * 10"
                    rounded
                    color="rgb(0, 84, 122)"
                    height="5"
                  ></v-progress-linear>
                </v-list-item-content>
              </v-flex>
              <v-flex lg6 class="pr-10 px-lg-16 mt-lg-0 mt-n3">
                <v-list-item-content>
                  <span class="text-lg-body-1 font-weight-bold"> Fluency </span> -->
    <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
    <!-- <span
                    class="text-lg-subtitle-1 mt-lg-2 mt-1"
                    style="color:rgb(205, 205, 205) !important"
                  >
                    {{ fluency[StudentData.score.fluency.value - 1] }}
                  </span>
                </v-list-item-content>
              </v-flex>

              <v-flex lg6 class="px-lg-16 px-1">
                <v-list-item-content class="mt-lg-2 mt-n4">
                  <span class="text-lg-h5 font-weight-bold progress-color1">
                    {{ StudentData.score.fluency.value * 10 }}
                  </span> -->
    <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
    <!-- <v-progress-linear
                    :value="StudentData.score.fluency.value * 10"
                    rounded
                    color="rgb(0, 84, 122)"
                    height="5"
                  ></v-progress-linear>
                </v-list-item-content>
              </v-flex>
            </v-layout>

            <v-flex lg12 xs12 class="text-center mt-lg-6 mt-5">
              <v-btn
                outlined
                color="white"
                class="rounded-lg py-7 py-lg-5"
                small
                @click="feedBack()"
              >
                Rate us
              </v-btn>

              <v-btn
                outlined
                color="white"
                class="ml-5 rounded-lg py-7 py-lg-5"
                small
                @click="enrollment()"
              >
                Enroll now!
              </v-btn>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout justify-center>
        <v-flex
          lg3
          class="text-center mt-10"
          v-show="windowwidth < 1200 ? true : false"
        >
          <v-btn
            class="mx-2 elevation-0"
            fab
            dark
            style="height:15px; width:15px;"
            :color="next == 1 ? 'rgb(3, 119, 188)' : 'rgb(16, 25, 43)'"
            @click="nextslide('1')"
          >
          </v-btn>
          <v-btn
            class="mx-2 elevation-0"
            fab
            dark
            style="height:15px; width:15px;"
            :color="next == 2 ? 'rgb(3, 119, 188)' : 'rgb(16, 25, 43)'"
            @click="nextslide('2')"
          >
          </v-btn>
          <v-btn
            class="mx-2 elevation-0"
            fab
            dark
            style="height:15px; width:15px;"
            :color="next == 3 ? 'rgb(3, 119, 188)' : 'rgb(16, 25, 43)'"
            @click="nextslide('3')"
          >
          </v-btn>
          <v-btn
            class="mx-2 elevation-0"
            fab
            dark
            style="height:15px; width:15px;"
            :color="next == 4 ? 'rgb(3, 119, 188)' : 'rgb(16, 25, 43)'"
            @click="nextslide('4')"
          >
          </v-btn>
          <v-btn
            class="mx-2 elevation-0"
            fab
            dark
            style="height:15px; width:15px;"
            :color="next == 5 ? 'rgb(3, 119, 188)' : 'rgb(16, 25, 43)'"
            @click="nextslide('5')"
          >
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container> -->
  </v-app>
</template>

<style scoped>
html {
  margin: 10px;
}
#evaluation {
  background: #000c17 !important;
  padding: 100px;
}
.card-bg {
  background-color: rgb(16, 25, 43);
  background-image: url("../../../assets/images/RegularClass/mega-man-white2.png");
  background-repeat: no-repeat;
  background-position: 100% 95%;
  background-size: 20%;
}
.font-24 {
  font-size: 24px !important;
}
.card-height {
  height: 621px;
}
.progress-color1 {
  color: #02a9f4 !important;
}
.logo-mega {
  max-height: 50px !important;
}
.logo-mega2 {
  max-height: 40px !important;
}
.logo-mega3 {
  max-height: 35px !important;
}
.mt-17 {
  margin-top: 100px;
}
.mt-18 {
  margin-top: 150px;
}
#journal-scroll::-webkit-scrollbar {
  width: 4px;
  cursor: pointer;
}
#journal-scroll::-webkit-scrollbar-track {
  background-color: rgba(229, 231, 235, var(--bg-opacity));
  cursor: pointer;
}
#journal-scroll::-webkit-scrollbar-thumb {
  cursor: pointer;
  background-color: #a0aec0;
}
.cd-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #f7fafc;
}

#progressButtonTimer,
#progressButtonVolume {
  margin-top: -9px;
  right: -8px;
}
.class-audio-btn {
  background-color: rgb(16, 25, 43) !important;
}

.font-12 {
  font-size: 12px !important;
}

.font-64 {
  font-size: 64px !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.correct-bg {
  background-color: #0377bc;
  border-radius: 2px;
}

.custom-outlined-card {
  background-color: transparent;
  border-radius: 10px;
  border: 1px solid #9e9e9e;
  color: #f0efef;
}

@media screen and (max-width: 900px) {
  #evaluation {
    background: #000c17 !important;
    padding: 20px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .mt-17 {
    margin-top: 0px;
  }
  .mt-18 {
    margin-top: 0px;
  }
  .font14 {
    font-size: 14px !important;
  }
  .font18 {
    font-size: 18px !important;
  }
  .font15 {
    font-size: 15px !important;
  }
  .card-bg {
    background-color: rgb(16, 25, 43);
    background-image: url("../../../assets/images/RegularClass/mega-man-white2.png");
    background-repeat: no-repeat;
    background-position: 100% 98%;
    background-size: 50%;
  }
  .card-height {
    height: 621px;
  }
  .card-height2 {
    height: 751px;
  }
  .logo-mega {
    max-height: 60px !important;
  }
  .logo-mega2 {
    max-height: 25px !important;
  }
  .logo-mega3 {
    max-height: 25px !important;
  }
  .class-audio-btn {
    width: 100% !important;
  }
}
</style>
<style scoped>
@import "../../../../src/assets/css/LevelTest/audioplayer.css";
</style>
<script>
import PieChartNew from "@/components/LevelTest/Report/PieChartNew";
import BarChartNew from "@/components/LevelTest/Report/BarChartNew";
import wordAudio from "@/components/LevelTest/Report/audioOne";
import AudioTwo from "@/components/LevelTest/Report/ClassRecordingAudio";
import Vue from "vue";
import axios from "axios";
Vue.use(axios);
export default {
  name: "evaluationformnew",
  components: {
    PieChartNew,
    BarChartNew,
    wordAudio,
    AudioTwo,
  },
  data: () => {
    return {
      next: 1,
      prev: 2,
      StudentData: null,
      StudentName: null,
      StudentRecordData: "",
      audioVal1: null,
      audioVal2: null,
      fileUrl: "",
      windowwidth: screen.width,
      x: "https://lex-audio.useremarkable.com/mp3/world_us_1.mp3",
      y: "https://lex-audio.useremarkable.com/mp3/beautiful_us_1.mp3",
      fileName: "",
      pronunciation: [
        "어색한 발음이 종종 있어 연습을 통해 개선의 필요가 있습니다.",
        "몇몇 단어들의 발음의 개선이 필요하나 간단한 단어들의 정확한 발음을 알고 있습니다.",
        "기본 단어의 발음들을 정확하게 인지하고 있습니다.",
        "어려운 단어를 제외하고는 정확한 발음을 구사합니다.",
        "기본적인 영어단어는 유창하게 발음하며 어려운 단어들도 어려움 없이 발음 할 수 있습니다.",
        "간단한 단어 및 어려운 단어들의 발음을 정확하게 알고 있습니다.",
        "많은 단어들을 정확하게 발음하며 새로운 단어 발음도 습득이 빠릅니다.",
        "간단한 단어 뿐만 아니라 어려운 단어들의 발음을 정확하게 알고 있습니다.",
        "모든 단어의 발음이 정확하고 유창합니다.",
      ],
      grammar: [
        "기본 문법을 공부하고 이해하는 것을 추천 드립니다.",
        "기본적인 문법 실력을 갖췄습니다.",
        "기본적인 문법의 지식은 갖추고 있으나 적용하는 방법에 보완이 필요합니다.",
        "기본 문법의 지식을 갖추고 있으며 적용하는 방법을 알고 있습니다.",
        "기본적 문법은 알고 있으며 대부분 문장에 적용을 하고 있습니다.",
        "기본적인 문법 뿐만 아니라 어려운 문법을 이해하고 적용할 수 있습니다.",
        "기본적인 문법 뿐만 아니라 어려운 문법을 이해하고 적용할 수 있습니다.",
        "기본적인 문법 뿐만 아니라 어려운 문법을 이해하고 적용할 수 있습니다.",
      ],
      vocabulary: [
        "학생의 어휘력은 여전히 향상되어야 합니다. 때때로 잠시 적당한 말이 떠오르기까지는 시간이 걸려요.",
        "올바른 단어를 찾기 위한 고군분투가 여전히 있었습니다. 학생들이 어휘력을 향상시키는 방법을 찾는 것이 필요합니다.",
        "학생은 어떻게든 좋은 말을 생각해 낼 수 있지만, 더 많은 연습이 필요합니다. 학생들이 자발적으로 영어로 말하는 것을 돕기 위해 어휘력을 계속 향상시키는 것은 매우 중요합니다.",
        "학생은 올바른 단어를 찾기로 결심했지만 어휘력을 향상시키고 더 많은 단어를 사용할 수 있도록 배우는 것이 필요합니다. 학생들은 의사소통을 잘 할 수 있는 더 나은 방법을 위해 향상시키기 위해 노력해야 합니다.",
        "학생은 대답할 때 올바른 단어를 사용할 수 있습니다. 하지만, 여전히 단어 실력을 늘려야 할 필요가 있습니다. 쉬운 단어의 동의어와 반의어를 확인하는 것이 큰 도움이 될 것입니다.",
        "학생은 수업 시간에 좋은 어휘를 사용하지만, 가끔 어휘를 잊어버립니다. 영어단어 공부에 대한 꾸준한 연습과 결단력이 학생들에게 많은 도움을 줄 수 있습니다.",
        "학생은 어휘가 좋아서 문장을 잘 만들 수 있습니다. 학생들이 계속해서 어휘를 습득할 수 있도록 격려한다면, 그 학생은 계속해서 발전할 것입니다.",
        "학생은 문맥에 따라 단어를 사용할 수 있습니다. 사용 중인 어휘가 고급입니다.",
      ],
      comprehension: [
        "이해력 부분에 다소 개선이 필요합니다.",
        "영어에 대한 이해도는 있으나, 때때로 문장을 이해하는데 어려움이 있습니다.",
        "간혹 어려운 단어의 뜻을 모르는 것을 제외하고는 중급의 이해도를 갖췄습니다.",
        "대화하는데 큰 어려움이 없으나 사용하는 단어의 다양성이 부족합니다.",
        "선생님의 말을 대부분 이해하며 높은 이해력을 갖췄습니다.",
        "선생님의 말하는 속도에 상관없이 모든 대화를 이해하는 높은 이해력을 갖췄습니다.",
        "빠르게 대화를 하여도 선생님과의 대화가 가능합니다.",
      ],
      fluency: [
        "영어로 자연스럽게 말하는 것에 조금 어려워 하며 완전한 문장을 만드는 부분에 보완이 필요합니다.",
        "영어로 대화하는 데에 다소 어려움이 있고, 대화중 멈추는 경우가 종종 있습니다. 간단한 문장을 만드는 연습이 필요합니다.",
        "말하는데 어려움은 없지만,  영어로 설명하는 부분에 있어서 다소 보완이 필요합니다. 구 또는 절을 만드는 것에는 어려움이 없지만 완전한 문장을 만드는 부분이 부족합니다.",
        "영어로 말할 수 있지만 선생님께 설명하는데 있어서 어려움이 있습니다. 구나 절을 구성할 수 있지만 문장을 완성하는데 어려움이 있습니다.",
        "대화 중 가끔 멈추는 부분이 있고 간단한 문장을 주로 만들지만 영어로 대화하는 것에는 능숙합니다.",
        "복잡한 문장도 구사를 하며 유창한 영어실력을 갖추고 있습니다. 다만 간혹 멈추는 부분의 보완이 필요합니다.",
        "멈추는 부분 없이 복잡한 문장을 자연스레 구사할 수 있습니다.",
        "멈추는 부분없이 복잡한 문장을 만들 수 있으며 어려운 단어들을 사용하여 수준높은 영어를 구사합니다.",
        "멈춤 없이 유창하게 대화를 할 수 있으며 어려움 없이 복잡한 문장을 만들 수 있습니다.",
      ],
      texttospeech1:false,
      texttospeech2:false,
      domain:"http://121.78.147.57:8000",
      file:[],

    };
  },
  mounted() {
    axios
      .get(
        "https://phone.megatalking.com/origin/api/leveltest_evaluation.php?l_id=" +
          this.$route.params.l_id +
          "&action=levelResult"
      )
      // .then(response=>console.warn(response.data))
      .then((response) => {this.StudentData = response.data.evaluation
        this.word1_audio(this.StudentData.feedBack.word[0]) 
        this.word2_audio(this.StudentData.feedBack.word[1])
      
      });

    // axios.get('https://phone.megatalking.com/origin/api/leveltest_evaluation.php?l_id='+this.$route.params.l_id+'&action=levelResult')
    // // .then(response=>console.warn(response.data))
    // .then((response)=> {this.StudentRecordData = response.data , console.log(this.StudentRecordData)})

    axios
      .get(
        "https://phone.megatalking.com/origin/api/leveltest_evaluation.php?l_id=" +
          this.$route.params.l_id +
          "&action=studentInfo"
      )
      // .then(response=>console.warn(response.data))
      .then((response) => (this.StudentName = response.data.name));
    // console.log(this.windowwidth)

    this.fetchingAPIKTT();

    var audio = this.$refs.audioOne;
    audio.addEventListener(
      "loadedmetadata",
      function() {
        this.initSlider();
      }.bind(this)
    );

    audio.addEventListener(
      "canplay",
      function() {
        this.audioLoaded = true;
      }.bind(this)
    );

    this.$watch("isPlaying", function() {
      if (this.isPlaying) {
        var audio = this.$refs.audioOne;
        this.initSlider();
        if (!this.listenerActive) {
          this.listenerActive = true;

          audio.addEventListener("freqtimeupdate", this.playbackListener);
        }
      }
    });
    this.$watch("playbackTime", function() {
      // var audio=this.$refs.audioOne;

      var diff = Math.abs(this.playbackTime - this.$refs.audioOne.currentTime);

      if (diff > 0.01) {
        this.$refs.audioOne.currentTime = this.playbackTime;
      }
    });
  },
  methods: {
    async fetchingAPIKTT() {
      await this.StudentRecordData;
      axios
        .get(
          "https://phone.megatalking.com/origin/api/leveltest_evaluation.php?l_id=" +
            this.$route.params.l_id +
            "&action=levelResult"
        )
        // .then(response=>console.warn(response.data))
        .then((response) => {
          (this.StudentRecordData = response.data),
            axios
              .get("https://phone.megatalking.com/origin/api/recordXML.php", {
                params: {
                  call_date: this.StudentRecordData.call_date,
                  phone_number: this.StudentRecordData.phone,
                },
              })
              .then((rs) => {
                let parser = new DOMParser();
                let xml = parser.parseFromString(rs.data, "application/xml");

                this.fetchingXMLRecording(xml);
                // console.log(xml)
              });
        });
    },

    fetchingXMLRecording(xml) {
      let dirname = xml.getElementsByTagName("dirname");
      let fname = xml.getElementsByTagName("fname");
      let call_time = xml.getElementsByTagName("call_time");

      let dir = "";
      let ct = [];
      let ct_get = "";
      // console.warn(record)

      for (let i = 0; i < call_time.length; i++) {
        ct.push(
          new Date("05-21-21 " + call_time[i].firstChild.nodeValue).getTime()
        );
      }

      ct_get = Math.max.apply(null, ct);

      for (let i = 0; i < dirname.length; i++) {
        if (
          new Date("05-21-21 " + call_time[i].firstChild.nodeValue).getTime() ==
          ct_get
        ) {
          dir = dirname[i].firstChild.nodeValue;
          this.file.push(fname[i].firstChild.nodeValue);
          break;
        }
      }
      // console.log(allFile)
      this.fileUrl = "http://121.78.147.57:8000" + dir + "" + this.file[0];
  

      //    liveserver
      axios
        .get(
          "https://phone.megatalking.com/origin/api/testaudio.php?file=" +
            this.file +
            "&domain="+this.domain+"&dir="+dir
        )
        .then((rs) => {
          this.fileName = rs.data;
        })
        .catch((error) => console.log("this is the error " + error));

      // local
      //     axios.get("http://localhost/megatalking/testaudio.php?file="+this.fileUrl+"").then(rs =>{ this.fileName = rs.data[0]
      //   });

      // console.warn('http://121.78.147.57:8000/'+this.valueXMl+''+this.fileName)
    },
    getDefinition(word,variable,errorword,texttospeech){
          axios
            .get(
              "https://api.dictionaryapi.dev/api/v2/entries/en_US/" + word
            )
            .then(
              (response) =>{
                  
                  this[variable] =  response.data[0].meanings[0].definitions[0].definition
                  this[texttospeech] = true
                  
                
              }).catch(
              (error) =>
                error ? (this[errorword] = true) : (this[errorword] = false),
              (this.e1 = 1)
            );
    },
    word1_audio(val) {
      axios
        .get("https://api.dictionaryapi.dev/api/v2/entries/en_US/" + val)
        .then(
          (response) => {this.audioVal1 = response.data[0].phonetics[0].audio
            if(!this.audioVal1){
              this.audioVal1 = response.data[0].phonetics[1].audio
              if(!this.audioVal1){
                    this.getDefinition(this.wordTwo,"audioVal1","errorword1","texttospeech1") 
                }
            }
          }
        ).catch(
              (error) =>
                error ? this.getDefinition(val,"audioVal1","errorword1","texttospeech1") : ''
            );
    },
    word2_audio(val) {
      axios
        .get("https://api.dictionaryapi.dev/api/v2/entries/en_US/" + val)
        .then(
          (response) => {this.audioVal2 = response.data[0].phonetics[0].audio

                     if(!this.audioVal2){
                      this.audioVal2 = response.data[0].phonetics[1].audio
                      if(!this.audioVal2){
                          this.getDefinition(this.wordTwo,"audioVal2","errorword2","texttospeech2") 
                      }
                     }

          }
        ).catch(
              (error) =>
                error ? this.getDefinition(val,"audioVal2","errorword2","texttospeech2") : ''
            );
    },
    MegaLevelName(val) {
      if (val == 1) {
        return "Low Beginner";
      } else if (val == 2) {
        return "Beginner";
      } else if (val == 3) {
        return "High <br/> Beginner";
      } else if (val == 4) {
        return "Low <br /> Intermediate";
      } else if (val == 5) {
        return "Intermediate";
      } else if (val == 6) {
        return "High <br /> Intermediate";
      } else if (val == 7) {
        return "Pre <br /> Advanced";
      } else if (val == 8) {
        return "Advanced";
      } else if (val == 9) {
        return "Post <br /> Advanced";
      } else {
        return " Undefined Level";
      }
    },
    ToeicLevel(val) {
      if (val == 1) {
        return "2";
      } else if (val == 2) {
        return "3";
      } else if (val == 3) {
        return "4";
      } else if (val == 4) {
        return "5";
      } else if (val == 5 || val == 6) {
        return "6";
      } else if (val == 7 || val == 8) {
        return "7";
      } else if (val == 9) {
        return "8";
      } else {
        return " Undefined Level";
      }
    },
    OpicLevel(val) {
      if (val == 1) {
        return "Novice Low";
      } else if (val == 2) {
        return "Novice Mid";
      } else if (val == 3) {
        return "Novice High";
      } else if (val == 4) {
        return "Intermediate Low";
      } else if (val == 5) {
        return "Intermediate Mid 1";
      } else if (val == 6) {
        return "Intermediate Mid 2";
      } else if (val == 7) {
        return "Intermediate Mid 3";
      } else if (val == 8) {
        return "Intermediate High";
      } else if (val == 9) {
        return "Advanced Low";
      } else {
        return " Undefined Level";
      }
    },
    nextslide(val) {
      if (val == 1) {
        return (this.prev = 2), (this.next = 1);
      } else if (val == 2) {
        if (this.prev >= 3) {
          return (this.next = 2), (this.prev = 3);
        } else if (this.prev <= 2) {
          return (this.next = 2), (this.prev = 2);
        }
      } else if (val == 3) {
        if (this.prev >= 4) {
          return (this.next = 3), (this.prev = 4);
        } else if (this.prev <= 3) {
          return (this.next = 3), (this.prev = 3);
        }
      } else if (val == 4) {
        if (this.prev >= 5) {
          return (this.next = 4), (this.prev = 5);
        } else if (this.prev <= 4) {
          return (this.next = 4), (this.prev = 4);
        }
      } else if (val == 5) {
        return (this.next = 5), (this.prev = 5);
      }
    },
    swipe(direction) {
      if (direction == "Left") {
        if (this.next < 5) {
          this.next++;
          this.prev++;
          
        }
      } else if (direction == "Right") {
        if (this.next > 1) {
          this.next--;
          this.prev--;
          
        }
      }
    },
    feedBack() {
      this.$router.push({
        name: "feedbackformStudentNew",
        params: { l_id: this.$route.params.l_id },
      });
    },
    enrollment() {
      window.location.href = "https://megatalking.co.kr/enrollment";
    },
  },
};
</script>
